import { orderBy } from 'lodash';

import type { Entity } from 'src/lib/collection';

export interface ImageStyle extends Entity {
  name: string;
}

export const DEFAULT_IMAGE_MODEL = 'realvis-xl-v4';

export const STYLE_IMAGES_MAX = 4;

export const DEFAULT_IMAGE_STYLE_ID = '0';
// The name the backend seeds the default general style with.
export const DEFAULT_IMAGE_STYLE_NAME = 'Let AI decide';

export const sortGeneralImageStyles = (imageStyles: ImageStyle[]): ImageStyle[] =>
  orderBy(imageStyles, ['id'], ['asc']);

export const sortCustomImageStyles = (imageStyles: ImageStyle[]): ImageStyle[] =>
  orderBy(imageStyles, ['name', 'id'], ['asc', 'asc']);

export const prepareImageSrc = ({
  url,
  pngBase64,
  jpgBase64,
}: {
  url: string;
  pngBase64: string;
  jpgBase64: string;
}) => {
  if (url) {
    return url;
  }
  if (pngBase64) {
    return `data:image/png;base64,${pngBase64}`;
  }
  if (jpgBase64) {
    return `data:image/jpeg;base64,${jpgBase64}`;
  }
  return null;
};
